export default "__VITE_ASSET__TF4Pr0dR__"